export const es = {
    common: {
        invest: "Invertir",
        details: "Detalles",
        contact: "Contacto",
        home: "Inicio",
        properties: "Propiedades",
        pricing: "Precios",
        blog: "Blog",
        agents: "Agentes",
        contactUs: "Contáctenos",
        login: "Iniciar sesión",
        signup: "Registrarse",
        logout: "Cerrar sesión",
        viewAll: "Ver todas las propiedades",
        readyToInvest: "¿Listo para invertir?",
        getStarted: "Empezar",
    },
    home: {
        heroTitle: "Encuentra la casa de tus sueños",
        heroSubtitle: "Te ayudamos a encontrar las mejores propiedades en la ciudad, convirtiendo tus sueños en realidad.",
        whyInvestTitle: "¿Por qué invertir en bienes raíces?",
        featuredProperties: "Propiedades Destacadas",
        featuredSubtitle: "Propiedades seleccionadas por nuestro equipo",
        investmentPlansTitle: "Niveles de Inversión",
        investmentPlansSubtitle: "Elija un nivel de inversión que se adapte a su estrategia. Los niveles más altos ofrecen períodos de bloqueo de capital más cortos.",
        pricingCTA: "Descubra el nivel de inversión perfecto para sus objetivos financieros, con términos flexibles y rendimientos competitivos.",
        viewPricing: "Ver Niveles",
        exploreProperties: "Explorar Oportunidades",
    },
    whyInvest: {
        secure: "Inversión Segura",
        secureDesc: "Descanse tranquilo con nuestras soluciones de inversión seguras, su futuro financiero está protegido",
        transparent: "Plataforma Transparente",
        transparentDesc: "Experimente la confianza de una plataforma transparente para su tranquilidad",
        passive: "Ingresos Pasivos",
        passiveDesc: "Explore oportunidades para generar flujos de ingresos pasivos",
        support: "Soporte",
        supportDesc: "Cuente con nuestro equipo de soporte dedicado para una asistencia rápida y confiable",
    },
    pricing: {
        starter: "Plan Inicial",
        growth: "Plan de Crecimiento",
        premium: "Plan Premium",
        benefits: {
            noFees: "Sin cargos ocultos",
            support: "Soporte al cliente 24/7",
            secure: "Pagos seguros en blockchain",
            flexible: "Términos de inversión flexibles",
        }
    },
    investment: {
        amount: "Monto de inversión",
        period: "Periodo de inversión",
        confirm: "Confirmar pago",
        minAmountError: "El monto mínimo de inversión es $1,000",
        confirmTitle: "Revisar y completar la inversión",
        awaitingConfirmation: "Esperando confirmación del pago",
        statusPending: "Estado: Pendiente de confirmación",
        viewMyInvestments: "Ver mis inversiones",
    }
};
